// extracted by mini-css-extract-plugin
module.exports = {"cell":"Table__cell"};